import { apiRequest } from '@/utils/api-request';
import { DefaultRoleOption } from '@/types/share-types';
import * as Sentry from '@sentry/react';

interface SetDefaultRoleResponse {
  data?: {
    workflow_id: string;
    default_role: string | null;
  };
  detail?: string;
}

/**
 * Set the default access role for a workflow.
 * - null = private (no default access)
 * - 'workflow:viewer' = all org members can see name/description
 * - 'workflow:editor' = all org members can view, edit, run, share
 */
export async function setWorkflowDefaultRole(
  orgId: string,
  workflowId: string,
  defaultRole: DefaultRoleOption,
): Promise<SetDefaultRoleResponse> {
  try {
    const response = await apiRequest<SetDefaultRoleResponse>({
      url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/default-role`,
      target: 'workflow',
      method: 'PUT',
      body: { default_role: defaultRole },
    });

    return response as SetDefaultRoleResponse;
  } catch (error) {
    Sentry.captureException(error, {
      extra: { context: 'set-workflow-default-role', workflowId, defaultRole },
    });
    throw error;
  }
}
